
import { Component, Watch } from "vue-property-decorator";
import Autocomplete from "@/components/common/Autocomplete.vue";
import BaseDynamicComponent from "../form-component.base";
import { DynamicFormEntry } from "@/app/dynamic-components/forms/dynamic-form.model";
import AutocompleteWithErrors from "@/app/components/AutocompleteWithErrors.vue";
import { Subject, Subscription } from "rxjs";
import { debounceTime } from "rxjs/operators";
import axios from "@/plugins/axios";
import { Overview } from "@/app/models/overview/overview.model";
import { getObjectContentsFromPath } from "@/app/helpers/stringpath.helper";
import DynamicComponentConfigManager from "@/app/components/configmanager/dynamic-component-config-manager.vue";

export type SelectFromEmbeddedMetaData = {
  path: string;

  items: unknown[];
  itemText: string;
  itemValue: string;

  clearable: boolean;
  dense: boolean;
  multiple: boolean;

  translate: boolean;
  autoSetOneItem: boolean;
  sortAlphabetically: boolean;
};
@Component({
  components: {
    DynamicComponentConfigManager,
    AutocompleteWithErrors,
    Autocomplete,
  },
})
export default class DynamicSelectFromEmbedded extends BaseDynamicComponent<SelectFromEmbeddedMetaData> {
  selectedList: string[] | string = [];
  list: any[] = [];
  formDataChangedSubscription: Subscription | null = null;
  path = "";
  public refreshingList = false;

  get displayList(): string {
    return this.list
      .filter((e) => {
        if (this.entry?.metadata?.itemValue) {
          return this.selectedList.includes(e[this.entry?.metadata?.itemValue]);
        } else {
          return this.selectedList.includes(e);
        }
      })
      .map((e) => {
        if (this.entry?.metadata?.itemText) {
          return e[this.entry?.metadata?.itemText];
        } else {
          return e;
        }
      })
      .join(", ");
  }

  postEntityChanged(entry: DynamicFormEntry) {
    if (entry && entry.metadata && entry.root) {
      let path = entry.metadata.path;
      path = entry.root.resolvePlaceholders(this.path);
      this.setNewPath(path);

      if (this.formDataChangedSubscription)
        this.formDataChangedSubscription.unsubscribe();
      this.formDataChangedSubscription = entry.root.formDataEmittor
          .pipe(debounceTime(500))
          .subscribe((val) => {
            const newPath = entry.root?.resolvePlaceholders(entry.metadata.path);
            if (newPath !== this.path) {
              this.setNewPath(newPath);
            }
          });
    }
  }

  @Watch("selectedList")
  onPersonsChanged() {
    this.setValueView(this.selectedList);
  }
  postSetValueView(value: any) {
    if (!value) {
      this.selectedList = [];
    } else {
      if (JSON.stringify(value) !== JSON.stringify(this.selectedList)) {
        this.selectedList = value;
      }
    }
  }


  postBeforeDestroy() {
    if (this.formDataChangedSubscription)
      this.formDataChangedSubscription.unsubscribe();
    this.formDataChangedSubscription = null;
  }

  private setNewPath(newPath: any) {
    if (!newPath) return;
    this.path = newPath;
    this.refreshingList = true;

    return axios
      .get<Overview>(newPath)
      .then((response) => {
        if (
          response.data &&
          response.data._embedded &&
          response.data._embedded["results"]
        ) {
          this.list = Array.from(response.data._embedded["results"]).map(
            (value) => {
              return {
                id: getObjectContentsFromPath(
                  this.entry.metadata.itemValue,
                  value
                ),
                label: getObjectContentsFromPath(
                  this.entry.metadata.itemText,
                  value
                ),
              };
            }
          );
        } else {
          this.list = [];
        }
        this.refreshingList = false;
      })
      .catch((reason) => {
        this.refreshingList = false;
      });
  }
}
